// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"

// Timezone conversion for datetime elements
function convertDatetimeWithTimezone() {
  document.querySelectorAll('.datetime-with-timezone').forEach(function(element) {
    const utcIso = element.getAttribute('data-utc-iso');
    if (!utcIso) return;

    try {
      const utcDate = new Date(utcIso);
      
      // Format as: "November 03, 2025 at 07:05 PM EST"
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      };
      
      const formatted = utcDate.toLocaleString('en-US', options);
      element.textContent = formatted;
    } catch (error) {
      console.warn('Failed to convert datetime with timezone:', error);
    }
  });
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  convertDatetimeWithTimezone();
});

// Also initialize on Turbo page loads (for SPA-like behavior)
document.addEventListener('turbo:load', function() {
  convertDatetimeWithTimezone();
});

import "trix"
import "@rails/actiontext"
// Import Lexxy - it will auto-initialize on rich_text_area fields
// Lexxy is in vendor/javascript/lexxy.js and needs to be bundled by esbuild
import "../../vendor/javascript/lexxy.js"
